export default __webpack_public_path__ + "41b54a3799067f92b304f1aed1a86d7d.jpg";